import {ShareButton} from "@/features/share-article";
import {Breadcrumbs} from "@/shared/ui/Breadcrumbs";
import {Svg} from "@/shared/ui/Svg";
import {Link} from "@/shared/ui/Link";
import {BlockRenderer} from "@/widgets/editor";
import {SaleOtherArticles} from "@/widgets/sale-other-articles";
import BaseLayout from "@/Layouts/BaseLayout";
import styles from "./SaleDetailedPage.module.scss";
import "@/Scss/Vendors/_react-editor.scss";

const Index = (props) => {
    const {sale = {}, otherArticlesData = {}, isMobile = false, hideBreadcrumbs = false} = props;
    const {body = {}, name = '', completed = 0} = sale;

    const {blocks = []} = body;

    return (
        <BaseLayout {...props}>
            <div className={styles.section}>
                <div className={`globalContainer`}>
                    <div className={styles.pageContainer}>
                        <Breadcrumbs
                            maxItems={3}
                            itemsAfterCollapse={2}
                            items={[
                                {label: "Главная", href: "/"},
                                {label: "Акции", href: "/stocks"},
                                {label: name},
                            ]}
                            // hideBreadcrumbs={hideBreadcrumbs}
                        />
                        <h1 className={styles.h1}>{name}</h1>
                        {completed === 1 && (
                            <h2>Акция завершена</h2>
                        )}
                        <div className={styles.actionContainer}>
                            <Link href={`/stocks`} className={styles.backButton}>
                                <Svg id={`arrowLeft`} className={styles.arrowLeftIcon} />
                                Назад
                            </Link>
                            <ShareButton text={name} isMobile={isMobile} />
                        </div>
                        {completed === 0 && (
                            <div className={styles.reEditorContainer}>
                                {blocks.map((block, i) => (
                                    <BlockRenderer key={i} block={block} />
                                ))}
                            </div>
                        )}
                        <SaleOtherArticles
                            titleSection={otherArticlesData.titleSection}
                            articles={otherArticlesData.articles}
                        />
                    </div>
                </div>
            </div>
        </BaseLayout>
    );
};

export default Index;
